export default [
  {
    path: '/visualizza-anagrafica',
    name: 'visualizza-anagrafica',
    component: () => import('@/views/anagrafica/PaginaAnagraficaUnica.vue'),
    meta: {
      resource: 'anagrafica',
      action: 'read',
      breadcrumb: [
        {
          text: 'Anagrafica',
        },
        {
          text: 'Anagrafica Unica',
          active: true,
        },
      ],
    },
  },
  {
    path: '/import-soggetti-anagrafica',
    name: 'import-soggetti-anagrafica',
    component: () => import('@/views/anagrafica/PaginaImportSoggettiAnagrafica.vue'),
    meta: {
      resource: 'import-anagrafica',
      action: 'read',
      breadcrumb: [
        {
          text: 'Anagrafica',
        },
        {
          text: 'Importazione Soggetti Anagrafica',
          active: true,
        },
      ],
    },
  },
  {
    path: '/storico-soggetto',
    name: 'storico-soggetto',
    component: () => import('@/views/anagrafica/PaginaStoricoSoggetto.vue'),
    meta: {
      resource: 'anagrafica',
      action: 'read',
      breadcrumb: [
        {
          text: 'Anagrafica',
        },
        {
          text: 'Storico Soggetto',
          active: true,
        },
      ],
    },
  },
]
